import React, { useState, useMemo, useEffect } from "react";
import { Container, Table, Button, Pagination, Col, Form, Spinner } from "react-bootstrap";
import { FileEarmarkExcel } from "react-bootstrap-icons";
import { useAuth } from "../../context/AuthContext";
import { esalonariApi } from "../../api/esalonariApi"; 
import { contractApi } from "../../api/contractApi";   
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";
import "./contracte.css";
import ModalEsalonare from "./modale/ModalEsalonare";
import ModalRealizari from "./modale/ModalRealizari";
import ModalEditareContract from "./modale/ModalEditareContract";
import ModalDetaliiPartida from "./modale/ModalDetaliiPartida";

const TabelContracte = ({ titlu, date, toatePartizile, setContracte, tema }) => {
  const { user } = useAuth();
  const [showEdit, setShowEdit] = useState(false);
  const [showDetalii, setShowDetalii] = useState(false);
  const [showEsalonare, setShowEsalonare] = useState(false);
  const [showRealizari, setShowRealizari] = useState(false);
  const [contractCurent, setContractCurent] = useState(null);
  const [partidaSelectata, setPartidaSelectata] = useState(null);
  const [partidaActiva, setPartidaActiva] = useState(null);
  const [dateEsalonare, setDateEsalonare] = useState([]);
  const [dateRealizari, setDateRealizari] = useState([]);
  const [seIncarcaEsalonare, setSeIncarcaEsalonare] = useState(false);
  const [cautareTabel, setCautareTabel] = useState("");
  const [paginaCurenta, setPaginaCurenta] = useState(1);
  const reperePePagina = 10;

  const [contracteLocale, setContracteLocale] = useState(date || []);

  useEffect(() => {
  setContracteLocale(date || []);
}, [date]);

  useEffect(() => { 
    setPaginaCurenta(1); 
  }, [cautareTabel]);

  // --- LOGICĂ APELURI API (ȘTERGERE, EDITARE, DESCHIDERE MODALE) ---
const handleEditeazaContract = async (id, dateNoi, partiziVechiIds) => {
  try {
    await contractApi.edit(id, dateNoi, partiziVechiIds);

    setContracteLocale((prev) =>
      prev.map((c) =>
        c.id === id ? { ...c, ...dateNoi } : c
      )
    );

    Swal.fire("Succes", "Contract actualizat!", "success");

    return true;
  } catch (err) {
    Swal.fire("Eroare", err.message, "error");

    return false;
  }
};


  const handleDelete = async (contract) => {
    const result = await Swal.fire({
      title: "Ești sigur?",
      text: `Vrei să ștergi contractul nr. ${contract.nrCtr}? Partizile asociate vor deveni din nou disponibile.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Da, șterge-l!",
      cancelButtonText: "Anulează",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`/api/contracte/${contract.id}`, { method: "DELETE" });
        if (!response.ok) throw new Error("Eroare la ștergerea de pe server.");
        if (typeof setContracte === "function") {
          setContracte((prev) => prev.filter((c) => c.id !== contract.id));
        }
        Swal.fire({ title: "Șters!", text: "Contractul a fost eliminat.", icon: "success", showConfirmButton: false, timer: 1500 });
      } catch (error) {
        Swal.fire("Eroare!", error.message, "error");
      }
    }
  };

  const deschideEsalonare = async (idPartida) => {
    setSeIncarcaEsalonare(true);
    const p = toatePartizile.find((part) => part.id === idPartida);
    setPartidaActiva(p);
    try {
      const dateExistente = await esalonariApi.get(idPartida);
      setDateEsalonare(dateExistente.map((d) => ({ id: d.id, luna: d.luna, volum: d.volum, suma: d.suma })));
      setShowEsalonare(true);
    } catch (err) {
      alert("Eroare la încărcare eșalonare.");
    } finally { 
      setSeIncarcaEsalonare(false); 
    }
  };

  const deschideRealizari = async (idPartida) => {
    setSeIncarcaEsalonare(true);
    const p = toatePartizile.find((part) => part.id === idPartida);
    setPartidaActiva(p);
    try {
      const dateE = await esalonariApi.get(idPartida);
      dateE.sort((a, b) => a.luna.localeCompare(b.luna));
      setDateRealizari(dateE.map((rand) => ({ 
        ...rand, 
        inputNou: 0, 
        inputPierderi: 0, 
        nrReceptieNou: "", 
        istoricReceptii: rand.istoricReceptii || [] 
      })));
      setShowRealizari(true);
    } catch (err) {
      alert("Eroare la încărcare realizări.");
    } finally { 
      setSeIncarcaEsalonare(false); 
    }
  };

  const adaugaLuna = () => {
    let nouaLuna = "";
    if (dateEsalonare.length > 0) {
      const ultimeleLuni = dateEsalonare.map((d) => d.luna).filter((l) => l).sort();
      const ultima = ultimeleLuni[ultimeleLuni.length - 1];
      if (ultima) {
        const [an, luna] = ultima.split("-").map(Number);
        const data = new Date(an, luna, 1);
        nouaLuna = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}`;
      }
    } else {
      const acum = new Date();
      nouaLuna = `${acum.getFullYear()}-${String(acum.getMonth() + 1).padStart(2, "0")}`;
    }
    const dejaExista = dateEsalonare.some((d) => d.luna === nouaLuna);
    setDateEsalonare([...dateEsalonare, { id: null, luna: dejaExista ? "" : nouaLuna, volum: 0, suma: 0 }]);
  };

  const tratezEditare = async (e) => {
  e.preventDefault();

  const contractOriginal = contracteLocale.find(
    (c) => c.id === contractCurent.id
  );

  const partiziVechiIds = contractOriginal
    ? contractOriginal.partiziAferente || []
    : [];

  const volumNou = contractCurent.partiziAferente.reduce((acc, id) => {
    const p = toatePartizile.find((part) => part.id === id);
    return acc + (p ? parseFloat(p.volBrut || 0) : 0);
  }, 0);

  const valoareNoua = contractCurent.partiziAferente.reduce((acc, id) => {
    const p = toatePartizile.find((part) => part.id === id);
    return acc + (p ? parseFloat(p.valTotal || 0) : 0);
  }, 0);

  const ok = await handleEditeazaContract(
    contractCurent.id,
    {
      ...contractCurent,
      volum: volumNou,
      valoare: valoareNoua,
    },
    partiziVechiIds
  );

  if (ok) {
    setShowEdit(false);
  }
};

  // --- VALORI TRANSMISE PRIN PROPS CĂTRE MODALE ---
  const totalEsalonat = useMemo(() => dateEsalonare.reduce((acc, r) => acc + parseFloat(r.volum || 0), 0), [dateEsalonare]);
  const esteDepasit = totalEsalonat > (partidaActiva?.volBrut || 0);
  const restDeEsalonat = (partidaActiva?.volBrut || 0) - totalEsalonat;

  const totalIntroducereNoua = useMemo(() => dateRealizari.reduce((acc, r) => acc + (parseFloat(r.inputNou) || 0) + (parseFloat(r.inputPierderi) || 0), 0), [dateRealizari]);
  
  const totalRealizatEfectiv = useMemo(() => dateRealizari.reduce((acc, rand) => {
    const istoric = rand.istoricReceptii || [];
    const sumIstoricV = istoric.reduce((s, h) => s + (parseFloat(h.volum) || 0), 0);
    const sumIstoricP = istoric.reduce((s, h) => s + (parseFloat(h.volumPierderi) || 0), 0);
    return acc + sumIstoricV + sumIstoricP + parseFloat(rand.inputNou || 0) + parseFloat(rand.inputPierderi || 0);
  }, 0), [dateRealizari]);

  const realizareExcesiva = totalRealizatEfectiv > (partidaActiva?.volBrut || 0);
  const procentTotalRealizat = partidaActiva?.volBrut > 0 ? (totalRealizatEfectiv / partidaActiva.volBrut) * 100 : 0;

  const partiziDisponibileEdit = toatePartizile.filter(p => p.stare === "disponibil" && p.ocol === contractCurent?.ocol && !contractCurent?.partiziAferente?.includes(p.id));
  const volumEdit = contractCurent?.partiziAferente?.reduce((acc, id) => acc + (toatePartizile.find(part => part.id === id) ? parseFloat(toatePartizile.find(part => part.id === id).volBrut || 0) : 0), 0) || 0;
  const valoareEdit = contractCurent?.partiziAferente?.reduce((acc, id) => acc + (toatePartizile.find(part => part.id === id) ? parseFloat(toatePartizile.find(part => part.id === id).valTotal || 0) : 0), 0) || 0;

  // --- FILTRARE ȘI PAGINARE PENTRU AFISARE TABEL ---
  const formateazaData = (ds) => {
    if (!ds) return "-";
    if (ds.seconds) return new Date(ds.seconds * 1000).toLocaleDateString("ro-RO");
    return new Date(ds).toLocaleDateString("ro-RO");
  };

  const datePermise = contracteLocale.filter((item) => user?.rol === "administrator" || item.ocol?.toString().trim().toLowerCase() === user?.ocol?.toString().trim().toLowerCase());
  
  const dateAfisateInTabel = useMemo(() => {
    if (!cautareTabel) return datePermise;
    const term = cautareTabel.toLowerCase();
    return datePermise.filter(item => item.nrCtr?.toString().toLowerCase().includes(term) || item.partener?.toLowerCase().includes(term) || item.ocol?.toLowerCase().includes(term));
  }, [datePermise, cautareTabel]);

  const totalPagini = Math.ceil(dateAfisateInTabel.length / reperePePagina);
  const datePaginate = useMemo(() => {
    const indexInceput = (paginaCurenta - 1) * reperePePagina;
    return dateAfisateInTabel.slice(indexInceput, indexInceput + reperePePagina);
  }, [dateAfisateInTabel, paginaCurenta]);



  const exportaExcel = () => {
    const dateExport = dateAfisateInTabel.map((item) => ({
      Ocol: item.ocol, "Nr. contract": item.nrCtr,
      Partizi: item.partiziAferente?.map(id => toatePartizile.find(part => part.id === id)?.fond || "Info").join(", "),
      "Volum (mc)": item.volum?.toFixed(2) || 0, "Valoare (RON)": parseFloat(item.valoare || 0).toLocaleString("ro-RO"),
      Data: formateazaData(item.dataCreare), Partener: item.partener,
    }));
    const worksheet = XLSX.utils.json_to_sheet(dateExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Contracte");
    XLSX.writeFile(workbook, `contracte_export_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const isDark = tema === "dark";

  return (
    <Container fluid className="mt-4">
      {/* HEADER */}
      <div className="d-flex align-items-center border-bottom mb-3 pb-2">
        <h3 className="text-success fw-bold mb-0">{titlu}</h3>
        <Col md={4} className="px-4">
          <Form.Control
            type="text"
            placeholder="Caută contract..."
            value={cautareTabel}
            onChange={(e) => setCautareTabel(e.target.value)}
            className="shadow-sm"
          />
        </Col>
        <Button
          variant="outline-success"
          className="ms-auto d-flex align-items-center"
          onClick={exportaExcel}
        >
          <FileEarmarkExcel size={20} className="me-2" /> Exportă în Excel
        </Button>
      </div>

      {/* COMPONENTA DE PAGINARE */}
      {totalPagini > 1 && (
        <div className="w-100 mt-3">
          <Pagination className="shadow-sm w-100 d-flex text-center">
            {[...Array(totalPagini)].map((_, idx) => {
              const numarPagina = idx + 1;
              const esteActiv = numarPagina === paginaCurenta;
              const stilNavigare = isDark
                ? {
                    backgroundColor: "#212529",
                    borderColor: "#495057",
                    color: "#fff",
                  }
                : {
                    backgroundColor: "#fff",
                    borderColor: "#dee2e6",
                    color: "#198754",
                  };
              return (
                <React.Fragment key={numarPagina}>
                  {idx === 0 && (
                    <>
                      <Pagination.First
                        onClick={() => setPaginaCurenta(1)}
                        disabled={paginaCurenta === 1}
                        style={{ flex: 1 }}
                        linkStyle={stilNavigare}
                      />
                      <Pagination.Prev
                        onClick={() =>
                          setPaginaCurenta((p) => Math.max(p - 1, 1))
                        }
                        disabled={paginaCurenta === 1}
                        style={{ flex: 1 }}
                        linkStyle={stilNavigare}
                      />
                    </>
                  )}
                  <Pagination.Item
                    active={esteActiv}
                    onClick={() => setPaginaCurenta(numarPagina)}
                    style={{ flex: 1 }}
                    linkStyle={
                      esteActiv
                        ? {
                            backgroundColor: "#198754",
                            borderColor: "#198754",
                            color: "#fff",
                          }
                        : stilNavigare
                    }
                  >
                    {numarPagina}
                  </Pagination.Item>
                  {idx === totalPagini - 1 && (
                    <>
                      <Pagination.Next
                        onClick={() =>
                          setPaginaCurenta((p) => Math.min(p + 1, totalPagini))
                        }
                        disabled={paginaCurenta === totalPagini}
                        style={{ flex: 1 }}
                        linkStyle={stilNavigare}
                      />
                      <Pagination.Last
                        onClick={() => setPaginaCurenta(totalPagini)}
                        disabled={paginaCurenta === totalPagini}
                        style={{ flex: 1 }}
                        linkStyle={stilNavigare}
                      />
                    </>
                  )}
                </React.Fragment>
              );
            })}
          </Pagination>
        </div>
      )}

      {/* COMPONENTA TABEL */}
      <Table
        hover
        responsive
        className={`tabel-contracte-custom rounded-4 ${isDark ? "border-secondary" : "border-light"}`}
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Nr. contract</th>
            <th>Data</th>
            <th>Ocol</th>
            <th>Volum (mc)</th>
            <th>Valoare (RON)</th>
            <th>Partener</th>
            <th style={{ width: "10%" }}>Partizi</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody className="align-middle text-center">
          {datePaginate.map((item, index) => {
            const indexReal = (paginaCurenta - 1) * reperePePagina + index + 1;
            return (
              <tr
                key={item.id || index}
                className={`shadow-sm ${isDark ? "border-secondary" : "border-light"}`}
              >
                <td>{indexReal}</td>
                <td className="celula-nr-contract">{item.nrCtr || "-"}</td>
                <td>{formateazaData(item.dataCreare)}</td>
                <td>{item.ocol}</td>
                <td className="fw-bold">
                  {item.volum?.toFixed(2) || 0}{" "}
                  <span className="small">mc</span>
                </td>
                <td>
                  {parseFloat(item.valoare || 0).toLocaleString("ro-RO")} lei
                </td>
                <td className="celula-partener">
                  <div>{item.partener}</div>
                </td>
                <td>
                  {item.partiziAferente?.map((idPartida) => {
                    const p = toatePartizile.find(
                      (part) => part.id === idPartida,
                    );
                    const esteReprimita = p?.stare === "reprimit";
                    return (
                      <div
                        key={idPartida}
                        className={`partida-card-container ${esteReprimita ? "reprimita" : ""}`}
                      >
                        <button
                          type="button"
                          className={`btn-partida-baza ${esteReprimita ? "bg-danger text-white" : isDark ? "btn-partida-dark" : "btn-partida-light"}`}
                          onClick={() => {
                            setPartidaSelectata(p);
                            setShowDetalii(true);
                          }}
                        >
                          <span>{p ? p.fond : "Info"}</span>
                          {esteReprimita && (
                            <span className="text-reprimita">Reprimită</span>
                          )}
                        </button>

                        <button
                          type="button"
                          className="btn-actiune-partida btn-actiune-esalonare text-warning"
                          onClick={() => deschideEsalonare(idPartida)}
                        >
                          <span>📊</span>
                          <span>Eșalonare</span>
                        </button>

                        <button
                          type="button"
                          className="btn-actiune-partida btn-actiune-exploatat text-success"
                          onClick={() => deschideRealizari(idPartida)}
                        >
                          <span>🌲</span>
                          <span>Exploatat</span>
                        </button>
                      </div>
                    );
                  })}
                </td>
                <td>
                  {user?.rol === "administrator" ? (
                    <div className="d-flex justify-content-center gap-2">
                      <button
                        type="button"
                        className="btn-cerc-actiune btn-cerc-editare"
                        onClick={() => {
                          setContractCurent({ ...item });
                          setShowEdit(true);
                        }}
                        title="Modifică Contract"
                      >
                        ✏️
                      </button>

                      <button
                        type="button"
                        className="btn-cerc-actiune btn-cerc-stergere"
                        onClick={() => handleDelete(item)}
                        title="Șterge Contract"
                      >
                        🗑️
                      </button>
                    </div>
                  ) : (
                    <span className="text-muted">🔒</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      {/* SPINNER */}
      {seIncarcaEsalonare && (
        <div className={`loading-overlay-global ${isDark ? "dark" : "light"}`}>
          <Spinner animation="border" variant="success" />
        </div>
      )}

      {/* APELURILE MODALELOR */}
      <ModalEsalonare
        show={showEsalonare}
        onHide={() => setShowEsalonare(false)}
        partidaActiva={partidaActiva}
        dateEsalonare={dateEsalonare}
        setDateEsalonare={setDateEsalonare}
        esteDepasit={esteDepasit}
        totalEsalonat={totalEsalonat}
        restDeEsalonat={restDeEsalonat}
        adaugaLuna={adaugaLuna}
      />
      <ModalRealizari
        show={showRealizari}
        onHide={() => setShowRealizari(false)}
        partidaActiva={partidaActiva}
        dateRealizari={dateRealizari}
        setDateRealizari={setDateRealizari}
        realizareExcesiva={realizareExcesiva}
        totalRealizatEfectiv={totalRealizatEfectiv}
        procentTotalRealizat={procentTotalRealizat}
        totalIntroducereNoua={totalIntroducereNoua}
      />
      <ModalEditareContract
        show={showEdit}
        onHide={() => setShowEdit(false)}
        contractCurent={contractCurent}
        setContractCurent={setContractCurent}
        toatePartizile={toatePartizile}
        partiziDisponibileEdit={partiziDisponibileEdit}
        volumEdit={volumEdit}
        valoareEdit={valoareEdit}
        tratezEditare={tratezEditare}
      />
      <ModalDetaliiPartida
        show={showDetalii}
        onHide={() => setShowDetalii(false)}
        partidaSelectata={partidaSelectata}
      />
    </Container>
  );
};

export default TabelContracte;